// extracted by mini-css-extract-plugin
export var dropdownButton = "_v-0";
export var fullWidthDropdownButton = "_v-1";
export var icon = "_v-3";
export var iconPlaceholder = "_v-2";
export var menuItemRow = "_v-9";
export var separator = "_v-e";
export var shortcutContainer = "_v-7";
export var shortcutContainerFilled = "_v-8";
export var shortcutIconLg = "_v-6";
export var shortcutIconMd = "_v-5";
export var shortcutIconSm = "_v-4";
export var submenuChevron = "_v-d";
export var submenuDropdown = "_v-a";
export var submenuTriggerRow = "_v-b";
export var submenuTriggerRowOpen = "_v-c";